export default __webpack_public_path__ + "static/media/banner-policy.55b6efad.png";